import React, { useEffect, useRef } from 'react';
import styled from 'styled-components';
import { srConfig, email, whatsappNumber, whatsappUrl } from '@config';
import sr from '@utils/sr';
import { usePrefersReducedMotion } from '@hooks';

const StyledContactSection = styled.section`
  max-width: 600px;
  margin: 0 auto 100px;
  text-align: center;

  @media (max-width: 768px) {
    margin: 0 auto 50px;
  }

  .overline {
    display: block;
    margin-bottom: 20px;
    color: var(--green);
    font-family: var(--font-mono);
    font-size: var(--fz-md);
    font-weight: 400;

    &:before {
      bottom: 0;
      font-size: var(--fz-sm);
    }

    &:after {
      display: none;
    }
  }

  .title {
    font-size: clamp(40px, 5vw, 60px);
  }

  .cta-row {
    display: flex;
    gap: 12px;
    justify-content: center;
    flex-wrap: wrap;
    margin-top: 50px;
  }

  .email-link {
    ${({ theme }) => theme.mixins.bigButton};
    margin-top: 0;
  }

  .whatsapp-link {
    ${({ theme }) => theme.mixins.bigButton};
    margin-top: 0;
    background-color: transparent;
    color: var(--green);

    &:hover,
    &:focus {
      background-color: var(--lightest-navy);
    }
  }
`;

const Contact = () => {
  const revealContainer = useRef(null);
  const prefersReducedMotion = usePrefersReducedMotion();

  useEffect(() => {
    if (prefersReducedMotion) {
      return;
    }

    sr.reveal(revealContainer.current, srConfig());
  }, []);

  return (
    <StyledContactSection id="contact" ref={revealContainer}>
      <h2 className="numbered-heading overline">What’s Next?</h2>

      <h2 className="title">Get In Touch</h2>

      <p>
        I’m open to new opportunities and collaborations. Whether you have a role in mind, a project
        to build, or just want to say hi, feel free to reach out and I’ll get back to you.
      </p>

      <div className="cta-row">
        <a className="email-link" href={`mailto:${email}`}>
          Email me
        </a>

        <a
          className="whatsapp-link"
          href={`${whatsappUrl}?text=${encodeURIComponent(
            'Hi Habib, I found your portfolio and would love to connect.',
          )}`}
          target="_blank"
          rel="noreferrer">
          WhatsApp {whatsappNumber}
        </a>
      </div>
    </StyledContactSection>
  );
};

export default Contact;
